// Module
var code = "<react-component name=\"WaiverSignedWaiversList\"></react-component>\n";
// Exports
module.exports = code;